import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap-5';
import { faHome } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  callListUrl,
  CALL_LISTS_SEARCH,
  CALL_LISTS_INDEX,
  mailersTemplatesUrl,
  mailersTemplateEditUrl
} from 'bundles/connect/helpers/prospect_api';
import MailersDownloadAll from './download_all';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

type MailersTemplatesHeaderProps = {
  callListId: number;
  templateTitle?: string;
  templateId?: number;
  setTemplateTitle?: React.Dispatch<React.SetStateAction<string>>;
  edit?: boolean;
};

export default function MailersTemplatesHeader({
  callListId,
  templateTitle,
  templateId,
  setTemplateTitle,
  edit = false
}: MailersTemplatesHeaderProps) {
  const [showAsInput, setShowAsInput] = useState(false);

  return (
    <div className="bg-white border-bottom p-4">
      <Row className="gy-3">
        <Col className="order-2 order-lg-1" lg>
          <Row className="flex-column gap-2">
            <Col className="d-flex justify-content-between">
              <nav>
                <ol className="breadcrumb my-0 align-items-center">
                  <li className="breadcrumb-item my-0">
                    <a className="text-muted" href={callListUrl(CALL_LISTS_SEARCH)}>
                      <FontAwesomeIcon icon={faHome} />
                    </a>
                  </li>
                  <li className="breadcrumb-item my-0">
                    <a className="text-muted" href={callListUrl(CALL_LISTS_INDEX)}>
                      Lists
                    </a>
                  </li>
                  {templateTitle && callListId && (
                    <li className="breadcrumb-item my-0">
                      <a className="text-muted" href={mailersTemplatesUrl(callListId)}>
                        Mailers
                      </a>
                    </li>
                  )}
                </ol>
              </nav>
              {(callListId && templateId) && (
                <div className="d-flex gap-3">
                  <Button href={mailersTemplateEditUrl(callListId, templateId)} variant="text-secondary">
                    <FontAwesomeIcon icon={faEdit} />
                    Back to Edit Template
                  </Button>
                  <MailersDownloadAll callListId={callListId} templateId={templateId} />
                </div>
              )}
            </Col>
            <Col xs={6}>
              {edit ? (
                showAsInput ? (
                  <Form.Control
                    autoFocus
                    type="text"
                    value={templateTitle}
                    onBlur={() => setShowAsInput(false)}
                    onChange={e => setTemplateTitle && setTemplateTitle(e.target.value)}
                  />
                ) : (
                  <Button className="py-2 pe-2 ps-0" variant="text" onClick={() => setShowAsInput(true)}>
                    <h5 className="mb-0 fw-bolder">{templateTitle}</h5>
                  </Button>
                )) : (
                <h5 className="mb-0 fw-bolder">{templateTitle}</h5>
              )}
              {!templateTitle && <h5 className="mb-0 fw-bolder">Mailers</h5>}
            </Col>
          </Row>
        </Col>
      </Row >
      <div className="d-none d-lg-block d-xl-none text-end" id="js-header-portal-tablet"></div>
    </div >
  );
}
